<template>
  <v-app-bar app color="#7E6990">
    <v-col class="d-flex" cols="12" sm="2">
      <v-select
        v-if="!open"
        :items="dashBoardList"
        label="ダッシュボード"
        solo
        hide-details
        v-model="dashboardSelected"
      ></v-select>
      <v-text-field
        v-if="open"
        hide-details
        label="ダッシュボード名"
        single-line
        v-model="dashboardSelectedName"
        dark
        @change="changeDashBoardName"
      ></v-text-field>
    </v-col>
    <div class="sidebar-open" :class="{'hidden': open}">
      <v-btn text @click="createDashBoard" dark rounded>
        <v-icon left>mdi-plus</v-icon>新規作成
      </v-btn>
      <v-btn text @click="editDashBoard" dark rounded>
        <v-icon left>mdi-pencil</v-icon>編集
      </v-btn>
      <v-btn text dark @click="clickShare" rounded>
        <v-icon left>mdi-share-variant</v-icon>共有
      </v-btn>
      <v-btn text @click="downloadDashBoardGraphs" dark rounded>
        <v-icon left>mdi-download</v-icon>ダウンロード
      </v-btn>
      <v-btn text dark @click="logout" rounded>
        <v-icon left>mdi-logout</v-icon>ログアウト
      </v-btn>
    </div>

    <div class="sidebar-close" :class="{'hidden': !open}">
      <v-btn text @click="saveDashBoard" dark rounded>
        <v-icon left>mdi-content-save</v-icon>保存
      </v-btn>
      <v-btn text @click="cancelDashBoard" dark rounded>
        <v-icon left>mdi-cancel</v-icon>キャンセル
      </v-btn>
      <v-btn v-if="egitFlg" text @click="deleteDashBoard" dark rounded>
        <v-icon left>mdi-delete</v-icon>削除
      </v-btn>
    </div>
    <v-spacer></v-spacer>
    <v-menu offset-y>
      <template v-slot:activator="{ on: menu }">
        <v-tooltip left>
          <template v-slot:activator="{ on:tooltip }">
            <v-btn icon dark v-on="{ ...tooltip, ...menu }">
              <v-icon>mdi-account-circle</v-icon>
            </v-btn>
          </template>
          <span>{{username}}</span>
        </v-tooltip>
      </template>
      <v-list rounded dense nav>
        <v-list-item-content>
          <v-list-item-title class="title">{{username}}</v-list-item-title>
          <v-list-item-subtitle>{{userid}}@{{domainid}}</v-list-item-subtitle>
        </v-list-item-content>
        <v-divider></v-divider>
        <v-list-item-group class="user-menu" v-if="!open">
          <v-list-item
            v-for="(item, index) in items"
            :key="index"
            @click="menuActionClick(item.action)"
          >
            <v-list-item-icon>
              <!-- <v-icon dark color="#7E6990" v-text="item.icon"></v-icon> -->
              <v-icon dark color="#7E6990">{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-menu>
    <v-icon left dark>AIDY</v-icon>
  </v-app-bar>
</template>
<script>
import { eventBus } from "../../main";
export default {
  // 一時的なチュートリアル削除に伴いコメントアウト(20230904)
  // 元に戻す場合は、下にあるdata: () => ({})を削除してください
  // data: () => ({
  //   dashBoardList: [],
  //   dashboardSelected: "",
  //   dashboardSelectedName: "",
  //   egitFlg: false,
  //   items: [
  //     {
  //       title: "チュートリアル",
  //       icon: "mdi-play-box-multiple",
  //       action: "tutorial"
  //     },
  //     { title: "ログアウト", icon: "mdi-logout", action: "logout" }
  //   ]
  // }),
  data: () => ({
    dashBoardList: [],
    dashboardSelected: "",
    dashboardSelectedName: "",
    egitFlg: false,
    items: [
      // 一時的なチュートリアル削除に伴いコメントアウト(20230904)
      // {
      //   title: "チュートリアル",
      //   icon: "mdi-play-box-multiple",
      //   action: "tutorial"
      // },
      { title: "ログアウト", icon: "mdi-logout", action: "logout" }
    ]
  }),
  created() {
    this.dashboardSelected = this.selectedDashBoard;
    this.setDashBoardList();
    this.updateSelectedDashBoardName();
  },
  mounted() {},
  watch: {
    dashboardSelected(val) {
      if (val) {
        this.$store.dispatch(
          "individual/SET_SELECTED_DASHBOARD",
          this.dashboardSelected
        );
      }
    },
    selectedDashBoard(val) {
      if (val) {
        this.dashboardSelected = this.selectedDashBoard;
        this.updateSelectedDashBoardName();
      }
    },
    dashBoards: {
      handler: function(val) {
        if (val) {
          this.setDashBoardList();
          this.$store.dispatch(
            "individual/SET_SELECTED_DASHBOARD",
            this.dashboardSelected
          );
        }
      },
      selectedDashBoard(val) {
        if (val) {
          this.setDashBoardList();
        }
      },
      deep: true
    }
  },
  computed: {
    open() {
      return this.$store.getters["topBar/open"];
    },
    dashBoards() {
      return this.$store.getters["individual/dashBoards"];
    },
    userid() {
      return this.$store.getters["logininfo/userid"];
    },
    username() {
      return this.$store.getters["logininfo/username"];
    },
    domainid() {
      return this.$store.getters["logininfo/domainid"];
    },
    selectedDashBoard: {
      get() {
        return this.$store.getters["individual/selectedDashBoard"];
      },
      set(editingDashBoard) {
        this.$store.dispatch(
          "individual/SET_SELECTED_DASHBOARD",
          editingDashBoard
        );
      }
    }
  },
  methods: {
    // toggleBar(){
    //   this.$store.dispatch('topBar/toggleBar')
    // },
    setDashBoardList() {
      var tmpDashBoardList = [];
      for (var i = 0; i < this.dashBoards.length; i++) {
        var pushObj = {
          text: this.dashBoards[i].dashBoardName,
          value: this.dashBoards[i].dashBoardId
        };
        tmpDashBoardList.push(pushObj);
      }
      this.dashBoardList = tmpDashBoardList;
    },
    createDashBoard() {
      this.egitFlg = false;
      eventBus.$emit("createDashBoard");
      this.dashboardSelectedName = "";
    },
    editDashBoard() {
      this.egitFlg = true;
      eventBus.$emit("editDashBoard");
    },
    updateSelectedDashBoardName() {
      for (var i = 0; i < this.dashBoards.length; i++) {
        if (this.dashBoards[i].dashBoardId === this.dashboardSelected) {
          this.dashboardSelectedName = this.dashBoards[i].dashBoardName;
        }
      }
    },
    saveDashBoard() {
      var saveConfirm = confirm("保存しますか？");
      if (saveConfirm) {
        eventBus.$emit("saveDashBoard");
        this.setDashBoardList();
        this.upsertOwnInfo();
      }
    },
    cancelDashBoard() {
      var cancelConfirm = confirm("保存した内容を削除して編集をやめますか？");
      if (cancelConfirm) {
        eventBus.$emit("cancelDashBoard");
        this.updateSelectedDashBoardName();
      }
    },
    deleteDashBoard() {
      var cancelConfirm = confirm(
        "ダッシュボード：" + this.dashboardSelectedName + "を削除しますか？"
      );
      if (cancelConfirm) {
        eventBus.$emit("deleteDashBoard");
        this.upsertOwnInfo();
      }
    },
    downloadDashBoardGraphs() {
      this.$router.push({ path: "download" });
      // eventBus.$emit("downloadDashBoardGraphs");
    },
    changeDashBoardName() {
      eventBus.$emit("changeDashBoardName", this.dashboardSelectedName);
    },
    logout() {
      this.$store.dispatch("logininfo/logout");
      this.$http
        .post(
          "/token/logout",
          {},
          {
            headers: {
              "X-CSRF-TOKEN": this.$cookies.get("csrf_access_token")
            }
          }
        )
        .then(res => {
          this.$router.push({ path: "login" });
        })
        .catch(error => {
          this.$router.push({ path: "login" });
        });
    },
    upsertOwnInfo() {
      this.$http
        .put(
          "/users/own",
          {
            dashBoards: this.$store.getters["individual/dashBoards"],
            indivisualInfo: this.$store.getters["individual/indivisualInfo"]
          },
          {
            headers: {
              "X-CSRF-TOKEN": this.$cookies.get("csrf_access_token")
            }
          }
        )
        .then(res => {
        })
        .catch(error => {
          // eslint-disable-next-line no-console
          console.log(error);
        });
    },
    clickShare() {
      this.$emit("click-share");
    },
    menuActionClick(action) {
      // 一時的なチュートリアル削除に伴いコメントアウト(20230904)
      // if (action === "tutorial") {
      //   this.$emit("display-tutorial");
      // } else if (action === "logout") {
      //   this.logout();
      // }
      if (action === "logout") {
        this.logout();
      }
    }
  }
};
</script>
<style scoped>
.d-flex {
  bottom: 0;
}
.sidebar-open {
  left: 250px;
}
.hidden {
  display: none;
}
.user-menu {
  margin-top: 5px;
}
</style>